import axios from 'axios'
import * as general_state from '../store';
import router from '../../router/router'
import moment from 'moment';
import { handleError } from '@/helpers/HandleError';

const state = {
	// User data (name, surname, email): user management for data table
	users_list_data: {},

	// All users
	added_users: {},

	// Deleted users
	deleted_users: {},

	// FAQ text
	faq_text: "",

	// Notices
	notices: {}
};


const getters = {
	// Return list of users 
	users_list_data: state => {
		return state.users_list_data;
	},

	// Return list of new users 
	new_users_list_data: state => {
		return state.added_users;
	},

	// Return list of deleted users 
	deleted_users_list_data: state => {
		return state.deleted_users;
	},

	// Returm faq text
	faq_text: state => {
		return state.faq_text;
	},

	// Returm notices
	notices: state => {
		return state.notices;
	},
};


const mutations = {
	// Prepare list of all sections for user
	setUserList: (state, payload) => {
		state.users_list_data = payload;
	},

	// Prepare list of all added users
	addUser: (state, payload) => {
		state.users_list_data = {
			...state.users_list_data,
			[payload.id]: payload
		};
	},

	// Remove user(s)
	deleteUser: (state, payload) => {
		const users_id = Array.isArray(payload) ? payload : [payload];
		const updated = { ...state.users_list_data };
		users_id.forEach(id => delete updated[id]);
		state.users_list_data = updated;
	},

	// Edit user
	editUser: (state, payload) => {

		//only update existing pairs
		const { id, ...rest } = payload;
		state.users_list_data[id] = {
		...state.users_list_data[id],
		...rest
		};

		/* state.users_list_data = {
			...state.users_list_data,
			[payload.id]: payload
		}; */
	},

	// Set access list for programs
	editUserPrograms: (state, payload) => {
		state.users_list_data = {
			...state.users_list_data,
			[payload.id]: {
				...state.users_list_data[payload.id],
				access_program_ids: payload.program_ids
			}
		};
	},

	// Set access list for departments
	editUserDepartments: (state, payload) => {
		state.users_list_data = {
			...state.users_list_data,
			[payload.id]: {
				...state.users_list_data[payload.id],
				access_oddelki_ids: payload.oddelki_ids
			}
		};
	},

	getFaq: (state, payload) => {
		state.faq_text = payload;
	},

	getNotices: (state, payload) => {
		state.notices = payload;
	},

	editNotice: (state, payload) => {
		state.notices = {
			...state.notices,
			[payload.id]: {
				...state.notices[payload.id],
				text: payload.text,
				tabs: payload.tabs
			}
		};
	},

	addNotice: (state, payload) => {
		const now = moment().format('YYYY-MM-DD HH:mm:ss');
		state.notices = {
			...state.notices,
			[payload.id]: {
				id: payload.id,
				tabs: payload.tabs,
				text: payload.text,
				created: now,
				last_updated: now
			}
		};
	},

	deleteNotice: (state, payload) => {
		const { [payload.id]: _, ...rest } = state.notices;
		state.notices = rest;
	}
};

const actions = {
	// Get users data for user management (userList): data table
	getUserList: ({ commit }) => {
		commit('showModalWorking');
		axios.get('?module=user&action=get_user_list')
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('setUserList', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get users data for user management for a faculty
	getUserListByFaculty: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=user&action=get_user_list_faculty&faculty_id=' + general_state.state.faculty.id)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('setUserList', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add New users data for user management (userList): data table
	addUser: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=user&action=add_user', payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');

						if (error.includes("Duplicate") && error.includes("email"))
							error = "Uporabnik s tem elektronskim naslovom že obstaja!"
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						payload.id = res.data.user_id;
						commit('addUser', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete user (userList): data table
	deleteUser: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=user&action=delete_user', { user_id: payload.id })
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka pri brisanju uporabnika!";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteUser', payload.id);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit user program access
	editUserPrograms: ({ commit }, payload) => {
		commit('showModalWorking');
		payload.user_id = payload.id;
		axios.post('?module=user&action=edit_user_programs', payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka pri urejanju uporabnika!";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editUserPrograms', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit user departments access
	editUserDepartments: ({ commit }, payload) => {
		commit('showModalWorking');
		payload.user_id = payload.id;
		axios.post('?module=user&action=edit_user_oddelki', payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka pri urejanju uporabnika!";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editUserDepartments', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit  users  (userList): data table
	editUser: ({ dispatch, commit }, payload) => {
		commit('showModalWorking');
		payload.user_id = payload.id;
		axios.post('?module=user&action=edit_user', payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka pri urejanju uporabnika!";
						if (error.includes("Duplicate") && error.includes("email"))
							error = "Uporabnik s tem elektronskim naslovom že obstaja!"
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						if(payload.id == general_state.state.user.id) 
							dispatch('editUserProfile', payload);
						commit('editUser', payload);
						commit('hideModalWorking');
						if (payload.show_message)
							commit('showModal', { component: 'ModalWarning', data: { title: "Uporabnik", description: "Podatki uporabnika uspešno posodobljeni" } })
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	editUserProfile: ({ commit, rootState }, payload) => {
		commit('setUser', {
			...rootState.user,
			name: payload.name,
			surname: payload.surname,
			email: payload.email,
			notifications: payload.notifications
		});
	},

	markNoticesAsRead: ({ commit, rootState }, payload) => {
		commit('setUser', {
			...rootState.user,
			notices_checked: payload
		});
	},

	// Set password of users (new user or lost password)
	setPassword: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=user&action=set_password', payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka pri natavitvi gesla!";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');

						//autologin
						dispatch('loginUser', payload);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Check if user did not yet set the password (does the hash still exist?)
	checkHash: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=user&action=check_hash', payload)
			.then(
				res => {
					commit('hideModalWorking');

					if (!res.data.success) {
						router.push('/login-password/');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get faq text
	getFaq: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=faq&action=get_faq&tab=' + payload.tab, payload)
			.then(
				res => {
					if (!res.data) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : "Napaka";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('getFaq', res.data.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save faq text
	sendFaq: ({ commit }, payload) => {
		console.log("sendFaq: ", payload);
		commit('showModalWorking');
		axios.post('?module=faq&action=save_faq&tab=' + payload.tab, payload)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('getFaq', payload.text);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get notices
	getNotices: ({ commit }) => {
		axios.get('?module=faq&action=get_notices')
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('getNotices', res.data);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get notices
	noticesRead: ({ dispatch }) => {
		axios.get('?module=faq&action=notices_read')
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						dispatch('markNoticesAsRead', res.data.read_time);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add notice
	addNotice: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=faq&action=add_notice', payload)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						payload.id = res.data.notice_id;
						commit('addNotice', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save notice
	editNotice: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=faq&action=edit_notice', payload)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						//even though i hide the previous main modal, it does not unmount in time, so modal below breaks it. if you want this to work find better solution
						//commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editNotice', payload);
						commit('hideModalWorking');
						//even though i hide the previous main modal, it does not unmount in time, so modal below breaks it. if you want this to work find better solution
						//commit('showModal', { component: 'ModalWarning', data: { title: "Obvestilo", description: "Obvestilo je uspešno shranjeno" } })
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	deleteNotice: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=faq&action=delete_notice', payload)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteNotice', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Action to password recovery
	passRecovery: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=other&action=pass_recovery', payload)
			.then(
				res => {
					commit('hideModalWorking');
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('showModal', { component: 'ModalError', data: error })
					}
					else if (res.data.success) {
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Geslo spremenjeno", description: "Sporočilo z navodili za aktivacijo novega gesla vam je bilo poslano na elektronsko pošto: " + payload.email }
						})
					}
					else {
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Napaka", description: res.data.error }
						})
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Send test mail
	sendTestEmail: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=user&action=mail_test', payload)
			.then(
				res => {
					commit('hideModalWorking');
					if (!res.data) {
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Napaka", description: "Pri pošiljanju obvestila na vaš elektronski nalsov je prišlo do napake" }
						})
						console.log(res.data);
					}
					else {
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Testno obvestilo", description: "Obvestilo je uspešno poslano na vaš elektronksi naslov" }
						})
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// send development test email
	sendTest: ({ commit }, payload) => {
		axios.get('?module=user&action=mail_test_dev')
			.then(
				res => {
					console.log(res);
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Send group mail
	sendGroupEmail: ({ commit }, payload) => {
		commit('showModalWorking');

		payload.year = general_state.state.active_year_date.active_year;
		axios.post('?module=user&action=mail_group', payload)
			.then(
				res => {
					commit('hideModalWorking');
					if (!res.data.success) {
						if (res.data.error == 'no_recipients') {
							commit('showModal', {
								component: 'ModalWarning',
								data: { title: "Opozorilo", description: "Za dane nastavitve ni obstoječih prejemnikov obvestila." }
							})
						}
						else {
							commit('showModal', {
								component: 'ModalWarning',
								data: { title: "Napaka", description: "Pri pošiljanju obvestila je prišlo do napake. Preverite svoj poštni predal - lahko, da nekaterim uporabnikom ni bila dostavljeno obvestilo." }
							})
						}
					}
					else {
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Pošiljanje bvestila", description: "Obvestilo je uspešno poslano " + res.data.data.recipients_count + " uporabnikom" }
						})
					}
				}
			)
			.catch(error => handleError(commit, error));
	},


	// Login user with salm
	loginUserSaml: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		return axios.post('?module=user&action=login_user_saml', payload)
			.then(
				res => {
					// Login succesful
					if (res.data.success === true) {
						commit('hideModalWorking');

						// Commit changes to store (user, faculty, token...)
						dispatch('getActiveYear');
						commit('setAuthData', res);
						commit('setToken', res.data.token);

						// Save token, faculty_id and user id to local storage
						localStorage.setItem('token', res.data.token);
						//localStorage.setItem('user_id', res.data.user.id);
						localStorage.setItem('faculty', JSON.stringify(res.data.faculty));
						localStorage.setItem('year', general_state.state.active_year_date.active_year);
						let expirationDate = new Date(new Date().getTime() + general_state.state.expirationTime).getTime();
						localStorage.setItem('expirationDate', expirationDate);

						//Redirect based on access
						if (general_state.state.user.access_sections == 1) {
							router.replace('/podrocja/');
						}
						else if (general_state.state.user.access_work_plan == 1) {
							router.replace('/program-dela/');
						}
						else if (general_state.state.user.access_evalvation == 1) {
							router.replace('/samoevalvacija/programi/');
						}
						
						// Start activity tracking after successful SAML login
						dispatch('startActivityTracking');
					}
					// Login failed
					else {
						commit('hideModalWorking');
						dispatch('clearMsalSession', null, { root: true });
						if (res.data.error == 'Uporabnik ni aktiven. Prosimo, kontaktirajte upravitelja na članici.') {
							commit('showModal', { component: 'ModalError', data: res.data.error });
						}
						else if (res.data.error == 'Uporabnik ne obstaja') {
							commit('showModal', { component: 'ModalError', data: "Napaka pri prijavi - uporabnik s podanim elektronskim naslovom ne obstaja" });
						}
						else {
							console.log(res.data.error);
							commit('showModal', { component: 'ModalError', data: "Napaka pri prijavi - za podrobnosti se obrnite na administratorja" });
						}
					}

					return res.data;
				}
			)
			.catch(error => {
				if (error.code === 'ECONNABORTED' || error.name === 'CanceledError') {
					console.log('Request canceled:', error.config?.url);
					return;
				}
				console.log('Request failed:', error);
			})
	},

	//Export package all sections data
	exportUsers: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		axios.get('?module=export&action=get_users_all')
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	//Export package all sections data
	exportProgramAccess: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		axios.post('?module=export&action=get_program_access', payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	//Change user type for admin for testing
	changeUserTypeTest: ({ commit, rootState }, payload) => {
		commit('setUser', {
			...rootState.user,
			type: payload
		});
	}
};


export default {
	state,
	getters,
	actions,
	mutations
}